import { ca } from '@cian/analytics';

export const trackOpenChatbot = (source?: string) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'ChatBot',
    action: 'Open_sopr',
    label: '',
    page: {
      extra: {
        chat_id: 'chatbot',
        source: source || 'Chat',
      },
    },
  });
};
